// ♥ «Сохранённые» анкеты карты (24.10.2026) — без входа, только в этом
// браузере: localStorage. Хранилище может быть недоступно (приватный режим,
// запрет сайта) — тогда список живёт до перезагрузки страницы, без ошибок.
//
// Поделиться — ссылкой /<lang>/tutors/saved?ids=<id>,<id>: id анкет (uuid),
// не slug — slug меняется при переименовании. Номера и данные родителя в
// ссылку не идут.
import { useSyncExternalStore } from "react";

const KEY = "yt_tutors_saved";
/** Больше — ссылка в WhatsApp становится неудобной. */
export const SAVED_MAX = 30;
const EVENT = "yt-tutors-saved";
const ID_RE = /^[0-9a-f-]{36}$/i;

let memory: string[] = [];
let cache: string[] | null = null;

function read(): string[] {
  if (cache) return cache;
  let ids = memory;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw) {
      const v = JSON.parse(raw);
      if (Array.isArray(v)) ids = v.filter((x): x is string => typeof x === "string" && ID_RE.test(x)).slice(0, SAVED_MAX);
    }
  } catch {
    /* хранилище недоступно — список в памяти */
  }
  cache = ids;
  return ids;
}

function write(ids: string[]) {
  memory = ids;
  cache = ids;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(ids));
  } catch {
    /* хранилище недоступно — список в памяти */
  }
  window.dispatchEvent(new Event(EVENT));
}

export function toggleSaved(id: string) {
  const ids = read();
  write(ids.includes(id) ? ids.filter((x) => x !== id) : [id, ...ids].slice(0, SAVED_MAX));
}

/** «Сохранить всех себе» со страницы, которой поделились. */
export function saveAll(add: string[]) {
  const ids = read();
  write([...add.filter((x) => !ids.includes(x)), ...ids].slice(0, SAVED_MAX));
}

function subscribe(cb: () => void) {
  const onStorage = (e: StorageEvent) => {
    if (e.key !== KEY) return;
    cache = null;
    cb();
  };
  window.addEventListener(EVENT, cb);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(EVENT, cb);
    window.removeEventListener("storage", onStorage);
  };
}

const NONE: string[] = [];
/** Сервер и первая отрисовка — пустой список (гидратация совпадает), дальше — из браузера. */
export function useSavedIds(): string[] {
  return useSyncExternalStore(subscribe, read, () => NONE);
}

/** ?ids=… из адреса: только похожие на id, без повторов, не больше SAVED_MAX. */
export function parseSavedIds(search: string): string[] | null {
  const raw = new URLSearchParams(search).get("ids");
  if (raw === null) return null;
  return [...new Set(raw.split(",").map((s) => s.trim()).filter((s) => ID_RE.test(s)))].slice(0, SAVED_MAX);
}

export function savedShareUrl(origin: string, path: string, ids: string[]): string {
  return `${origin}${path}?ids=${ids.join(",")}`;
}
